import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useJWTAuthActions } from '../../services/JWTAuthProvider';
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../common/modal";

export const ChangePassword = ({ isOpen, closeCallback }) => {
    const navigate = useNavigate();

    const [showToast, setShowToast] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [inputErrors, setInputErrors] = useState({});
    const [passwordMatchError, setPasswordMatchError] = useState(false);
    const [passwordRegexError, setPasswordRegexError] = useState(false);
    const [samePasswordMatchError, setSamePasswordMatchError] = useState(false);
    const { changeUserPassword } = useJWTAuthActions();
    const [showoldPassword, setShowoldPassword] = useState(false);
    const [showNewPassword, setShownewPassword] = useState(false);
    const [showConfirmPassword, setsShowconfirmPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowoldPassword(!showoldPassword);
    };

    const toggleNewPasswordVisibility = () => {
        setShownewPassword(!showNewPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setsShowconfirmPassword(!showConfirmPassword);
    };


    const navigateToLogin = () => {
        navigate('/login');
    };

    const validatePassword = (password) => {
        const isLengthValid = password.length >= 8 && password.length <= 16;
        const hasSpecialCharacter = /[!@#$%^&*()_+{}[\]:;<>,.?~\\-]/.test(password);
        const hasCapitalLetter = /[A-Z]/.test(password);
        return isLengthValid && hasSpecialCharacter && hasCapitalLetter;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (oldPassword === '' || newPassword === '' || confirmPassword === '') {
            setInputErrors({
                oldPassword: oldPassword === '',
                newPassword: newPassword === '',
                confirmPassword: confirmPassword === '',
            });
            return;
        }
        if (oldPassword === newPassword) {
            setSamePasswordMatchError(true);
            return;
        }
        if (newPassword !== confirmPassword) {
            setPasswordMatchError(true);
            return;
        }
        setShowToast(true);
    };

    const closePassword = () => {
        clearError('oldPassword');
        clearError('newPassword');
        clearError('confirmPassword');
        closeCallback();
    }

    const restPassword = async () => {
        if (oldPassword === '' || newPassword === '' || confirmPassword === '') {
            setInputErrors({
                oldPassword: oldPassword === '',
                newPassword: newPassword === '',
                confirmPassword: confirmPassword === '',
            });
            return;
        }

        if (oldPassword === newPassword) {
            setSamePasswordMatchError(true);
            return;
        }
        if (newPassword !== confirmPassword) {
            setPasswordMatchError(true);
            return;
        }

        if (newPassword === '') {
            setInputErrors((prevErrors) => ({
                ...prevErrors,
                newPassword: '* New password is required',
            }));
            return;
        }
        else {
            if (!validatePassword(newPassword)) {
                setPasswordRegexError(true);
                return;
            }
        }

        await changeUserPassword({
            oldpassword: oldPassword,
            newpassword: newPassword
        });
    }

    const clearError = (fieldName) => {
        setInputErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: false,
        }));
    };

    const closeToast = () => {
        setShowToast(false);
    };
    return (
        <Modal isLarge={false} isOpen={isOpen}>
            <ModalHeader>
                {<h5 className="modal-title">Change Password</h5>}
            </ModalHeader>
            <ModalBody>
                <form className='add-form' onSubmit={handleSubmit}>
                    <label className='form-label'>Old Password</label>
                    <div className={`input-wrap ${inputErrors.oldPassword ? 'error' : ''}`}>
                        <input
                            type={showoldPassword ? 'text' : 'password'}
                            className='form-control'
                            value={oldPassword}
                            onChange={(e) => {
                                setOldPassword(e.target.value);
                                clearError('oldPassword');
                                clearError('newPassword');
                                clearError('confirmPassword');
                            }}
                        />
                        <div className={`input-img ${showoldPassword ? 'show-pass' : 'hide-pass'}`} onClick={togglePasswordVisibility}>
                        </div>
                    </div>
                    {inputErrors.oldPassword && <p className='error-message'>* Old Password is required</p>}

                    <label className='form-label'>New Password</label>
                    <div className={`input-wrap ${inputErrors.newPassword ? 'error' : ''}`}>
                        <input
                            type={showNewPassword ? 'text' : 'password'}
                            className='form-control'
                            value={newPassword}
                            onChange={(e) => {
                                setNewPassword(e.target.value);
                                clearError('newPassword');
                                setPasswordMatchError(false);
                                setSamePasswordMatchError(false);
                                setPasswordRegexError(false);
                            }}
                        />
                        <div className={`input-img ${showNewPassword ? 'show-pass' : 'hide-pass'}`} onClick={toggleNewPasswordVisibility}>
                        </div>
                    </div>
                    {inputErrors.newPassword && <p className='error-message'>* new Password is required</p>}
                    {samePasswordMatchError && <p className='error-message'>* New Password should not be same as Old Password</p>}
                    {passwordRegexError && <p className='error-message'> * Password must be 8 - 16 characters and have at least one capital letter, small letter and special character(! @#$ % ^ & *?.) </p>}
                    <label className='form-label'>Confirm Password</label>
                    <div className={`input-wrap ${inputErrors.confirmPassword ? 'error' : ''}`}>
                        <input
                            type={showConfirmPassword ? 'text' : 'password'}
                            className='form-control'
                            value={confirmPassword}
                            onChange={(e) => {
                                setConfirmPassword(e.target.value);
                                clearError('confirmPassword');
                                setPasswordMatchError(false);
                                setSamePasswordMatchError(false);
                                setPasswordRegexError(false);
                            }}
                        />
                        <div className={`input-img ${showConfirmPassword ? 'show-pass' : 'hide-pass'}`} onClick={toggleConfirmPasswordVisibility}>
                        </div>
                    </div>
                    {inputErrors.confirmPassword && <p className='error-message'>* Confirm Password is required</p>}
                    {passwordMatchError && <p className='error-message'>* Confirm Password does not match the New Password</p>}
                    <span className='back-login' onClick={closePassword}>
                        Cancel
                    </span>
                    <div className='login-btn'>
                        <button className='btn-primary' type='button' onClick={restPassword}>
                            Submit
                        </button>
                    </div>
                </form>
                <div className={`toast-message ${showToast ? 'active' : ''}`}>
                    Success! Password changed successfully. <span className='close-btn' onClick={closeToast}>X</span>
                </div>
            </ModalBody>
        </Modal>
    )
}
